import { useState } from 'react';
import Layout from '../../../components/layout/Layout';
import { useNavigate } from 'react-router-dom';

interface Venda {
  id: string;
  campanha: string;
  participante: string;
  pdv: string;
  cnpj: string;
  produto: string;
  sku: string;
  valor: string;
  status: 'aprovada' | 'reprovada' | 'em_auditoria' | 'pendente' | 'aguardando_doc';
  origem: 'integracao' | 'upload' | 'ocr';
  risco: 'baixo' | 'medio' | 'alto';
  data: string;
}

export default function VendasAuditoriaPage() {
  const navigate = useNavigate();
  const [filtros, setFiltros] = useState({
    campanha: '',
    regiao: '',
    pdv: '',
    status: '',
    periodo: '30dias',
    risco: ''
  });

  const [vendas] = useState<Venda[]>([
    {
      id: 'VND-2024-001',
      campanha: 'Black Friday 2024',
      participante: 'João Silva',
      pdv: 'Supermercado Central',
      cnpj: '12.345.678/0001-90',
      produto: 'Smartphone Galaxy S23',
      sku: 'SM-S911B',
      valor: 'R$ 3.499,00',
      status: 'aprovada',
      origem: 'integracao',
      risco: 'baixo',
      data: '15/12/2024'
    },
    {
      id: 'VND-2024-002',
      campanha: 'Natal Premium',
      participante: 'Maria Santos',
      pdv: 'Farmácia Saúde Total',
      cnpj: '23.456.789/0001-01',
      produto: 'Kit Perfumaria',
      sku: 'PERF-001',
      valor: 'R$ 450,00',
      status: 'em_auditoria',
      origem: 'upload',
      risco: 'medio',
      data: '14/12/2024'
    },
    {
      id: 'VND-2024-003',
      campanha: 'Black Friday 2024',
      participante: 'Pedro Oliveira',
      pdv: 'Loja de Eletrônicos Tech',
      cnpj: '34.567.890/0001-12',
      produto: 'Notebook Dell Inspiron',
      sku: 'DELL-INS15',
      valor: 'R$ 4.299,00',
      status: 'aguardando_doc',
      origem: 'ocr',
      risco: 'alto',
      data: '13/12/2024'
    },
    {
      id: 'VND-2024-004',
      campanha: 'Natal Premium',
      participante: 'Ana Costa',
      pdv: 'Padaria Pão Quente',
      cnpj: '45.678.901/0001-23',
      produto: 'Cesta de Natal',
      sku: 'CESTA-NAT',
      valor: 'R$ 189,90',
      status: 'aprovada',
      origem: 'integracao',
      risco: 'baixo',
      data: '12/12/2024'
    },
    {
      id: 'VND-2024-005',
      campanha: 'Black Friday 2024',
      participante: 'Carlos Mendes',
      pdv: 'Pet Shop Amigo Fiel',
      cnpj: '56.789.012/0001-34',
      produto: 'Ração Premium 15kg',
      sku: 'RAC-PREM-15',
      valor: 'R$ 299,00',
      status: 'reprovada',
      origem: 'upload',
      risco: 'alto',
      data: '11/12/2024'
    },
    {
      id: 'VND-2024-006',
      campanha: 'Natal Premium',
      participante: 'Juliana Lima',
      pdv: 'Mercadinho do Bairro',
      cnpj: '67.890.123/0001-45',
      produto: 'Panetone Artesanal',
      sku: 'PAN-ART-01',
      valor: 'R$ 85,00',
      status: 'em_auditoria',
      origem: 'ocr',
      risco: 'medio',
      data: '10/12/2024'
    },
    {
      id: 'VND-2024-007',
      campanha: 'Black Friday 2024',
      participante: 'Roberto Alves',
      pdv: 'Loja de Roupas Fashion',
      cnpj: '78.901.234/0001-56',
      produto: 'Jaqueta de Couro',
      sku: 'JAQ-COURO-M',
      valor: 'R$ 899,00',
      status: 'pendente',
      origem: 'integracao',
      risco: 'baixo',
      data: '09/12/2024'
    },
    {
      id: 'VND-2024-008',
      campanha: 'Natal Premium',
      participante: 'Fernanda Rocha',
      pdv: 'Açougue Premium',
      cnpj: '89.012.345/0001-67',
      produto: 'Kit Churrasco Premium',
      sku: 'CHUR-PREM',
      valor: 'R$ 650,00',
      status: 'aprovada',
      origem: 'upload',
      risco: 'baixo',
      data: '08/12/2024'
    }
  ]);

  const getStatusBadge = (status: string) => {
    const badges = {
      aprovada: { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'Aprovada', icon: 'ri-checkbox-circle-line' },
      reprovada: { bg: 'bg-red-100', text: 'text-red-700', label: 'Reprovada', icon: 'ri-close-circle-line' },
      em_auditoria: { bg: 'bg-orange-100', text: 'text-orange-700', label: 'Em Auditoria', icon: 'ri-time-line' },
      pendente: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Pendente', icon: 'ri-hourglass-line' },
      aguardando_doc: { bg: 'bg-amber-100', text: 'text-amber-700', label: 'Aguardando Doc', icon: 'ri-file-warning-line' }
    };
    const badge = badges[status as keyof typeof badges];
    return (
      <span className={`inline-flex items-center space-x-1 px-3 py-1 rounded-full text-xs font-semibold ${badge.bg} ${badge.text}`}>
        <div className="w-3 h-3 flex items-center justify-center">
          <i className={badge.icon}></i>
        </div>
        <span>{badge.label}</span>
      </span>
    );
  };

  const getOrigemBadge = (origem: string) => {
    const badges = {
      integracao: { bg: 'bg-blue-50', text: 'text-blue-700', label: 'Integração', icon: 'ri-link' },
      upload: { bg: 'bg-purple-50', text: 'text-purple-700', label: 'Upload Manual', icon: 'ri-upload-2-line' },
      ocr: { bg: 'bg-teal-50', text: 'text-teal-700', label: 'OCR/Cupom', icon: 'ri-scan-line' }
    };
    const badge = badges[origem as keyof typeof badges];
    return (
      <span className={`inline-flex items-center space-x-1 px-2 py-1 rounded text-xs font-medium ${badge.bg} ${badge.text}`}>
        <div className="w-3 h-3 flex items-center justify-center">
          <i className={badge.icon}></i>
        </div>
        <span>{badge.label}</span>
      </span>
    );
  };

  const getRiscoBadge = (risco: string) => {
    const badges = {
      baixo: { bg: 'bg-emerald-50', text: 'text-emerald-700', label: 'Baixo' },
      medio: { bg: 'bg-amber-50', text: 'text-amber-700', label: 'Médio' },
      alto: { bg: 'bg-red-50', text: 'text-red-700', label: 'Alto' }
    };
    const badge = badges[risco as keyof typeof badges];
    return (
      <span className={`px-2 py-1 rounded text-xs font-medium ${badge.bg} ${badge.text}`}>
        {badge.label}
      </span>
    );
  };

  const vendasFiltradas = vendas.filter(venda => {
    if (filtros.campanha && !venda.campanha.toLowerCase().includes(filtros.campanha.toLowerCase())) return false;
    if (filtros.pdv && !venda.pdv.toLowerCase().includes(filtros.pdv.toLowerCase())) return false;
    if (filtros.status && venda.status !== filtros.status) return false;
    if (filtros.risco && venda.risco !== filtros.risco) return false;
    return true;
  });

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Vendas para Auditoria</h1>
            <p className="text-sm text-gray-600 mt-1">Gerencie e audite todas as vendas recebidas</p>
          </div>
          <div className="flex items-center space-x-3">
            <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-download-line"></i>
              </div>
              <span>Exportar</span>
            </button>
            <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-upload-2-line"></i>
              </div>
              <span>Upload Manual</span>
            </button>
          </div>
        </div>

        {/* Filtros */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900">Filtros Avançados</h3>
            <button
              onClick={() => setFiltros({ campanha: '', regiao: '', pdv: '', status: '', periodo: '30dias', risco: '' })}
              className="text-sm text-blue-600 hover:text-blue-800 cursor-pointer whitespace-nowrap"
            >
              Limpar filtros
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Campanha</label>
              <input
                type="text"
                value={filtros.campanha}
                onChange={(e) => setFiltros({ ...filtros, campanha: e.target.value })}
                placeholder="Buscar campanha..."
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Região</label>
              <select
                value={filtros.regiao}
                onChange={(e) => setFiltros({ ...filtros, regiao: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">Todas as regiões</option>
                <option value="sudeste">Sudeste</option>
                <option value="sul">Sul</option>
                <option value="nordeste">Nordeste</option>
                <option value="norte">Norte</option>
                <option value="centro-oeste">Centro-Oeste</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">PDV</label>
              <input
                type="text"
                value={filtros.pdv}
                onChange={(e) => setFiltros({ ...filtros, pdv: e.target.value })}
                placeholder="Buscar PDV..."
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
              <select
                value={filtros.status}
                onChange={(e) => setFiltros({ ...filtros, status: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">Todos os status</option>
                <option value="aprovada">Aprovada</option>
                <option value="reprovada">Reprovada</option>
                <option value="em_auditoria">Em Auditoria</option>
                <option value="pendente">Pendente</option>
                <option value="aguardando_doc">Aguardando Doc</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Período</label>
              <select
                value={filtros.periodo}
                onChange={(e) => setFiltros({ ...filtros, periodo: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="7dias">Últimos 7 dias</option>
                <option value="30dias">Últimos 30 dias</option>
                <option value="90dias">Últimos 90 dias</option>
                <option value="ano">Último ano</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Grau de Risco</label>
              <select
                value={filtros.risco}
                onChange={(e) => setFiltros({ ...filtros, risco: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">Todos os riscos</option>
                <option value="baixo">Baixo</option>
                <option value="medio">Médio</option>
                <option value="alto">Alto</option>
              </select>
            </div>
          </div>
        </div>

        {/* Tabela de Vendas */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">ID</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Campanha</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Participante</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">PDV</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Produto</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Valor</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Status</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Origem</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Risco</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Ações</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {vendasFiltradas.map((venda) => (
                  <tr key={venda.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-sm font-medium text-gray-900">{venda.id}</span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-sm text-gray-900">{venda.campanha}</span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-sm text-gray-900">{venda.participante}</span>
                    </td>
                    <td className="px-6 py-4">
                      <div>
                        <p className="text-sm font-medium text-gray-900">{venda.pdv}</p>
                        <p className="text-xs text-gray-500">{venda.cnpj}</p>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div>
                        <p className="text-sm text-gray-900">{venda.produto}</p>
                        <p className="text-xs text-gray-500">SKU: {venda.sku}</p>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="text-sm font-semibold text-gray-900">{venda.valor}</span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {getStatusBadge(venda.status)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {getOrigemBadge(venda.origem)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {getRiscoBadge(venda.risco)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <button
                        onClick={() => navigate(`/admin/auditoria/vendas/${venda.id}`)}
                        className="text-blue-600 hover:text-blue-800 cursor-pointer whitespace-nowrap flex items-center space-x-1"
                      >
                        <div className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-eye-line"></i>
                        </div>
                        <span className="text-sm font-medium">Auditar</span>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between">
            <p className="text-sm text-gray-600">
              Mostrando <span className="font-semibold">{vendasFiltradas.length}</span> de <span className="font-semibold">{vendas.length}</span> vendas
            </p>
            <div className="flex items-center space-x-2">
              <button className="px-3 py-1 border border-gray-300 rounded-lg text-sm text-gray-700 hover:bg-gray-100 cursor-pointer whitespace-nowrap">
                Anterior
              </button>
              <button className="px-3 py-1 bg-blue-600 text-white rounded-lg text-sm cursor-pointer whitespace-nowrap">
                1
              </button>
              <button className="px-3 py-1 border border-gray-300 rounded-lg text-sm text-gray-700 hover:bg-gray-100 cursor-pointer whitespace-nowrap">
                2
              </button>
              <button className="px-3 py-1 border border-gray-300 rounded-lg text-sm text-gray-700 hover:bg-gray-100 cursor-pointer whitespace-nowrap">
                3
              </button>
              <button className="px-3 py-1 border border-gray-300 rounded-lg text-sm text-gray-700 hover:bg-gray-100 cursor-pointer whitespace-nowrap">
                Próximo
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
